import React, { useRef } from 'react';
import FlipBook from 'react-pageflip';
import 'tailwindcss/tailwind.css';
import courseTwo from '../images/course/course-1.png'
import bookTwo from "../images/course/pageOne.png"
import { Link } from 'react-router-dom'


//icons
import { PiTelevisionBold } from "react-icons/pi";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { RiWhatsappLine } from "react-icons/ri";



const CourseTwo = () => {

    function top() {
        window.scroll(0, 0)
    }

    const bookRef = useRef();

    const handleNext = () => {
        bookRef.current.pageFlip().flipNext();
    };

    const handlePrev = () => {
        bookRef.current.pageFlip().flipPrev();
    };

    return (
        <div className="flex flex-col justify-center items-center w-full h-screen rounded-md font-[poppins] cursor-grab">
            <FlipBook
                width={310}
                height={460}
                className=""
                ref={bookRef}
            >
                {/* Cover Page */}
                <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-l-md md:rounded-r-none">
                    <div>
                        <img src={courseTwo} alt="Cover" className=" object-cover w-full rounded-b-sm" />
                    </div>

                    <div>

                        <div className="flex flex-col items-center mt-8">

                            <h3 className="text-[12px] sm:text-[12px] md:text-[14px] mb-4 text-gray-900 uppercase  font-normal border border-gray-400  px-3 py-1 w-fit rounded-md ">
                                1 Year course in
                            </h3>

                            <h3 className=" text-[14px] sm:text-[16px] md:text-[18px] mb-2  font-semibold uppercase font-[Open Sans] text-gray-800">
                                Visual Effects & CG
                            </h3>


                        </div>

                        <div className='flex justify-center items-center mt-4'>
                            <Link to='one-year-course' onClick={top}>
                                <button className="flex items-center  gap-x-2 border rounded-md border-gray-400 hover:scale-105 duration-500 hover:bg-white hover:text-gray-900  bg-gray-900 text-white shadow-md drop-shadow-md shadow-gray-400 text-[10px] sm:text-[12px] md:text-[14px] px-3 py-2 md:py-1.5 md:px-5">
                                    Learn More <IoIosArrowForward className='text-white font-bold text-[14px]' />
                                </button>
                            </Link>
                        </div>

                    </div>

                </div>


                {/* Page 1 */}
                <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-r-md md:rounded-l-none">
                    <div className="px-4 py-8 flex flex-col gap-y-7">

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'> Introduction to VFX & Adobe Tools</h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-4 text-gray-800 text-[12px] md:text-[12px] '>
                                   
                                   
                                </ul> */}

                            </div>

                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>Rotoscopy and Matte Painting </h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>Rotoscopy Fundamentals</li>
                                    <li>Understanding Rotoscopy Techniques </li>
                                    <li>Rotoscoping Softwares: Silhouette, Mocha Pro  </li>
                                    <li>Matte Painting Techniques </li>
                                    <li>Digital Painting Fundamentals</li>
                                    <li> Matte Painting Workflow</li>
                                    <li>Software: Adobe Photoshop</li>
                                </ul> */}
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>Matchmove and Motion Graphics</h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>Introduction to Matchmove </li>
                                    <li>Matchmove Fundamentals </li>
                                    <li>Tracking Techniques </li>
                                    <li>Software: PFTrack, Boujou </li>
                                    <li>Motion Graphics </li>
                                    <li>Motion Graphics Principles </li>
                                    <li>Animation Techniques in After Effects </li>
                                    <li>Software: Adobe After Effects </li>
                                </ul> */}
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>Fundamentals of Blender & Unreal Engine </h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>Introduction to Blender</li>
                                    <li> Blender Interface and Navigation</li>
                                    <li> Modeling Tools and Techniques</li>
                                    <li>Texturing and Shading in Blender</li>

                                </ul> */}
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className=' bg-white h-4 w-4 md:h-5 md:w-5 shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>3D Modeling and Animation with Autodesk Maya </h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li> Introduction to Autodesk Maya </li>
                                    <li> Maya Interface and Navigation </li>
                                    <li> Polygonal Modeling Techniques </li>
                                    <li> Advanced Modeling and Texturing in Maya </li>
                                    <li> NURBS Modeling and Organic Modeling </li>
                                    <li> Texture Mapping and UV Layouts </li>
                                    <li> Rigging and Animation in Maya </li>
                                    <li> Character Rigging Techniques </li>
                                    <li> Keyframe Animation and Animation Layers </li>
                                </ul> */}

                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className='font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>Lighting, Rendering, and Optimization</h3>


                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px]'>
                                    <li>Lighting and Rendering Techniques</li>
                                    <li>Types of Lights and Lighting Setups </li>

                                </ul> */}
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className='font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'>Compositing with Nuke</h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px]'>
                                    <li>Introduction to Nuke</li>
                                    <li>Nuke Interface and Node-based Workflow</li>
                                    <li>Basic Compositing Techniques</li>
                                    <li>Advanced Compositing Techniques in Nuke</li>
                                    <li>Keying and Rotoscoping</li>
                                    <li> 3D Compositing and Tracking</li>


                                </ul> */}
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className=' bg-white shadow-md h-4 w-4 md:h-5 md:w-5 rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[13px]'> AI Integration and Ethical Use</h3>

                                {/* <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>AI Tools in VFX </li>
                                    <li>Overview of AI Integration in VFX </li>
                                    <li>Use Cases and Applications </li>
                                    <li>Ethical Use of AI in VFX </li>
                                    <li>Understanding Bias and Fairness </li>
                                    <li>Ethical Considerations in AI-Generated Content </li>

                                </ul> */}
                            </div>
                        </div>




                    </div>
                </div>

                {/* Page 2 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-l-md md:rounded-r-none">

                    <div className="px-4 py-8 flex flex-col gap-y-8">

                        <div className='flex items-start gap-x-2'>

                            <div className='h-4 w-4 md:h-5 md:w-5 drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Motion Graphics with After Effects & Cinema 4D - 6 Months</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li> Rotoscoping and Masking</li>
                                    <li>Chroma Keying (Green Screen)</li>
                                    <li> Tracking and Stabilization</li>
                                </ul>
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Rotoscopy and Matte Painting </h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>Rotoscopy Fundamentals</li>
                                    <li>Understanding Rotoscopy Techniques </li>
                                    <li>Rotoscoping Softwares: Silhouette, Mocha Pro  </li>
                                    <li>Matte Painting Techniques </li>
                                    <li>Digital Painting Fundamentals</li>
                                    <li> Matte Painting Workflow</li>
                                    <li>Software: Adobe Photoshop</li>

                                </ul>
                            </div>
                        </div>
                    </div>

                </div> */}

                {/* Page 3 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-r-md md:rounded-l-none">

                    <div className="px-4 py-8 flex flex-col gap-y-8">

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Matchmove and Motion Graphics</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>Introduction to Matchmove </li>
                                    <li>Matchmove Fundamentals </li>
                                    <li>Tracking Techniques </li>
                                    <li>Software: PFTrack, Boujou </li>
                                    <li>Motion Graphics </li>
                                    <li>Motion Graphics Principles </li>
                                    <li>Animation Techniques in After Effects </li>
                                    <li>Software: Adobe After Effects </li>

                                </ul>
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Fundamentals of Blender & Unreal Engine </h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>Introduction to Blender</li>
                                    <li> Blender Interface and Navigation</li>
                                    <li> Modeling Tools and Techniques</li>
                                    <li>Texturing and Shading in Blender</li>



                                </ul>
                            </div>
                        </div>
                    </div>

                </div> */}

                {/* Page 3 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-l-md md:rounded-r-none">
                    <div className="px-4 py-8 flex flex-col gap-y-8">

                        <div className='flex items-start gap-x-2'>

                            <div className=' h-4 w-4 md:h-5 md:w-5  drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Diploma Project </h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>

                                    <li> UV Unwrapping and Texture Painting</li>
                                    <li>Shading and Material Creation</li>
                                    <li>Lighting, Rigging, and Animation in Blender</li>
                                    <li> Basics of Lighting and Rendering</li>
                                    <li>Rigging Characters and Objects</li>
                                    <li>Animation Principles and Techniques</li>
                                    <li>Introduction to Unreal Engine</li>
                                    <li>Familiarization with the interface, navigation, and basic tools.</li>
                                    <li>Techniques for building environments, setting up lighting, and applying materials</li>
                                    <li> Basics of animating objects and cameras, and creating cinematic sequences.</li>
                                    <li>Understanding the fundamentals of real-time rendering for film production.</li>

                                </ul>
                            </div>
                        </div>



                    </div>
                </div> */}

                {/* Page 4 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-r-md md:rounded-l-none">
                    <div className="px-4 py-8 flex flex-col gap-y-8">

                        <div className='flex items-start gap-x-2'>

                            <div className=' bg-white h-4 w-4 md:h-5 md:w-5 shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>3D Modeling and Animation with Autodesk Maya </h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li> Introduction to Autodesk Maya </li>
                                    <li> Maya Interface and Navigation </li>
                                    <li> Polygonal Modeling Techniques </li>
                                    <li> Advanced Modeling and Texturing in Maya </li>
                                    <li> NURBS Modeling and Organic Modeling </li>
                                    <li> Texture Mapping and UV Layouts </li>
                                    <li> Rigging and Animation in Maya </li>
                                    <li> Character Rigging Techniques </li>
                                    <li> Keyframe Animation and Animation Layers </li>


                                </ul>
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className='font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Lighting, Rendering, and Optimization</h3>


                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px]'>
                                    <li>Lighting and Rendering Techniques</li>
                                    <li>Types of Lights and Lighting Setups </li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </div> */}

                {/* Page 5 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-l-md md:rounded-r-none ">
                    <div className="px-4 py-8 flex flex-col gap-y-8">

                        <div className='flex items-start gap-x-2'>

                            <div className=' h-4 w-4 md:h-5 md:w-5  rounded-full flex justify-center items-center'>
                                <PiTelevisionBold  className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px]'>
                                    <li>Introduction to Render Engines (Arnold, V-Ray) </li>
                                    <li>Rendering Optimization </li>
                                    <li>Render Settings Optimization </li>
                                    <li>Render Passes and AOVs </li>
                                </ul>

                            </div>
                        </div>


                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className='font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Compositing with Nuke</h3>


                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px]'>
                                    <li>Introduction to Nuke</li>
                                    <li>Nuke Interface and Node-based Workflow</li>
                                    <li>Basic Compositing Techniques</li>
                                    <li>Advanced Compositing Techniques in Nuke</li>
                                    <li>Keying and Rotoscoping</li>
                                    <li> 3D Compositing and Tracking</li>


                                </ul>
                            </div>
                        </div>

                    </div>
                </div> */}

                {/* Page 6 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-r-md md:rounded-l-none">
                    <div className="px-4 py-8 flex flex-col gap-y-8">

                        <div className='flex items-start gap-x-2'>

                            <div className=' bg-white shadow-md h-4 w-4 md:h-5 md:w-5 rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'> AI Integration and Ethical Use</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>AI Tools in VFX </li>
                                    <li>Overview of AI Integration in VFX </li>
                                    <li>Use Cases and Applications </li>
                                    <li>Ethical Use of AI in VFX </li>
                                    <li>Understanding Bias and Fairness </li>
                                    <li>Ethical Considerations in AI-Generated Content </li>

                                </ul>
                            </div>
                        </div>

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className='font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Diploma Project : Integrative Projects and Portfolio Development</h3>


                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px]'>
                                    <li>Project Development</li>
                                    <li>Collaborative Projects integrating various VFX techniques</li>
                                    <li>Portfolio Building and Presentation Skills</li>

                                </ul>
                            </div>
                        </div>

                    </div>
                </div> */}

                {/* Page 7 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md">
                    <div className="px-4 py-8 flex flex-col gap-y-10">

                        <div className='flex items-start gap-x-2'>

                            <div className='bg-white h-4 w-4 md:h-5 md:w-5 shadow-md drop-shadow-md rounded-full flex justify-center items-center'>
                                <PiTelevisionBold  className="text-gray-900  p-0.5 h-4 w-4 md:h-5 md:w-5" />
                            </div>

                            <div className=' font-[roboto]'>
                                <h3 className='font-semibold text-[12px] md:text-[14px]'>Month 12:</h3>

                                <ul className='flex flex-col gap-y-2 list-disc ml-3 mt-2 text-gray-800 text-[12px] md:text-[12px] '>
                                    <li>AI Integration and Ethical Use</li>
                                    <li>AI Tools in VFX ○ Overview of AI Integration in VFX </li>
                                    <li>Use Cases and Applications</li>
                                    <li>Ethical Use of AI in VFX </li>
                                    <li>Understanding Bias and Fairness</li>
                                    <li>Ethical Considerations in AI-Generated Content</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Page 8 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md md:rounded-l-md md:rounded-r-none">
                    <div>
                        <img src={bookTwo} alt="Cover" className=" object-cover w-full rounded-r-md md:rounded-l-md md:rounded-r-none" />
                    </div>
                </div> */}

                {/* Page 9 */}
                {/* <div className="flex justify-center items-center w-full h-full bg-white border border-gray-300 rounded-r-md">
                    <div className='px-4 py-8 flex flex-col gap-y-10 justify-center items-center my-auto h-full'>

                        <div>
                            <h3 className='text-[18px]  font-semibold text-center uppercase'>Join the Academy of Aspiring Filmmakers!</h3>
                        </div>
                        <div className='mt-4 flex justify-center items-center'>
                            <a href="https://api.whatsapp.com/send?phone=9884683888" target="_blank" rel="noopener noreferrer" className="">

                                <button className='bg-gray-900 text-white shadow-md drop-shadow-md h-9 pl-3 rounded-md flex items-center gap-x-3  font-[poppins] text-[12px] md:text-[14px] hover:scale-105 duration-500'> Download syllabus <div className='px-3 bg-green-600  rounded-r-md'><RiWhatsappLine className='text-white h-9   text-[22px] font-bold' /> </div>  </button>
                            </a>
                        </div>
                    </div>
                </div> */}
            </FlipBook >
            <div className="mt-4 flex space-x-4">

                <button onClick={handlePrev} className="flex items-center gap-2 border rounded-md border-gray-900 hover:scale-105 duration-500 hover:bg-white hover:text-gray-900   text-gray-900 text-[10px] sm:text-[12px] md:text-[14px] px-3 py-2 md:py-2 md:px-4">
                    <IoIosArrowBack className='text-gray-900' />
                </button>

                <button onClick={handleNext} className="flex items-center gap-2 border rounded-md border-gray-900 hover:scale-105 duration-500 hover:bg-white hover:text-gray-900   text-gray-900 text-[10px] sm:text-[12px] md:text-[14px] px-3 py-2 md:py-2 md:px-4">
                    <IoIosArrowForward className='text-gray-900' />
                </button>

            </div>
        </div >
    );
};

export default CourseTwo;
